/** @jsx jsx */
import { FC } from "react";
import { jsx } from "@emotion/react";
import { useFormatMsg } from "src/hooks/useFormatMsg";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const ConfigButton: FC<PurposedButtonProps> = (props) => {
  const formatMsg = useFormatMsg();
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="config-button"
      buttonColor={colors.secondaryColor}
      tooltip={formatMsg("table.export_table.columns_visibility.settings")}
      css={labellessButtonCss}
      iconName="tune"
      {...props}
    />
  );
};

export default ConfigButton;
